import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { UserProfilePictureRepo } from "@app/core/user/domain/repositories/user-profile-picture.repo";
import { UploadPhotoCapacitor } from "@app/core/user/data/capacitor/upload-photo.capacitor";
import { TakePhotoCameraCapacitor } from "@app/core/user/data/capacitor/take-photo-camera.capacitor";

/**
 * User repository that implements the user logic using the capacitor API.
 */
@Injectable()
export class UserCapacitorRepo implements UserProfilePictureRepo {
  constructor(
    private uploadPhotoCapacitor: UploadPhotoCapacitor,
    private takePhotoCameraCapacitor: TakePhotoCameraCapacitor
  ) {}

  uploadPhoto(): Observable<string> {
    return this.uploadPhotoCapacitor.execute();
  }
  takePhoto(): Observable<string> {
    return this.takePhotoCameraCapacitor.execute();
  }
}
